import ILegalEntity from './ILegalEntity';
import ILegalEntityInput from './ILegalEntityInput';
import * as ActionTypes from './ActionTypes';
import LegalEntitiesApi from './LegalEntitiesApi';

function newLegalEntitySucceeded(result: ILegalEntity): any {
    return { type: ActionTypes.NEW_LEGAL_ENTITY_SUCCESS, result: result };
}

export function newLegalEntity(): (dispatch: (result: any) => void, getState: any) => any {
    return (dispatch: (result: any) => void, getState: any) =>
        LegalEntitiesApi.newLegalEntity().then((result: any) => {
            dispatch(newLegalEntitySucceeded(result));
        });
}

function createSucceeded(result: ILegalEntity): any {
    return { type: ActionTypes.CREATE_LEGAL_ENTITY_SUCCESS, result: result };
}

export function create(
    input: ILegalEntityInput
): (dispatch: (result: any) => void, getState: any) => any {
    return (dispatch: (result: any) => void, getState: any) =>
        LegalEntitiesApi.create(input).then((result: ILegalEntity) => {
            dispatch(createSucceeded(result));
        });
}

export function listSucceeded(result: ILegalEntity[]) {
    return { type: ActionTypes.LIST_LEGAL_ENTITY_SUCCESS, result: result };
}

export function list(): (dispatch: (result: any) => void, getState: any) => any {
    return (dispatch: (result: any) => void, getState: any) =>
        LegalEntitiesApi.list().then((result: ILegalEntity[]) => {
            dispatch(listSucceeded(result));
        });
}

function editSucceeded(result: ILegalEntity) {
    return { type: ActionTypes.EDIT_LEGAL_ENTITY_SUCCESS, result: result };
}

export function edit(id: number) {
    return (dispatch: (result: any) => void) =>
        LegalEntitiesApi.edit(id).then((result: ILegalEntity) => {
            dispatch(editSucceeded(result));
        });
}

function updateSuccess(result: ILegalEntity) {
    return { type: ActionTypes.UPDATE_LEGAL_ENTITY_SUCCESS, result: result };
}

export function update(legalEntity: ILegalEntityInput, id: number) {
    return (dispatch: any) =>
        LegalEntitiesApi.update(legalEntity, id).then((result: ILegalEntity) => {
            dispatch(updateSuccess(result));
        });
}

function deleteSucceeded(result: number) {
    return { type: ActionTypes.DELETE_LEGAL_ENTITY_SUCCESS, result };
}

export function deleteLegalEntity(id: number) {
    return (dispatch: (result: any) => void) =>
        LegalEntitiesApi.delete(id).then((result: any) => {
            dispatch(deleteSucceeded(id));
        });
}
